export interface DirectDebitBankDetails {
  accountName: string;
  accountNumber: string;
  sortCode: string;
  payeeAccountType: DirectDebitPayeeAccountType;
  isUKAccountAndAccountHolder: string;
  canAuthoriseDD: string;
}

export interface DirectDebitPaymentSchedule {
  ownerAccountNumber: string;
  startDate: string;
  monthlyAmount: number;
  paymentDay: string;
  monthlyFrequency: number;
  paymentsRemaining: number;
  balanceType: DirectDebitBalanceType;
  yearlyTotal?: string;
}

export interface DirectDebitTermOption {
  numberOfOccurrences: number;
  monthlyAmount: number;
}

export interface DirectDebit {
  directDebitId: number;
  accountId: number;
  year: number;
  amount: number;
  paymentDay: number;
  monthlyFrequency: number;
  startMonth: number;
  startYear: number;
  maxPayments: number;
  balanceType: DirectDebitBalanceType;
}

export enum DirectDebitBalanceType {
  Let2Own = 'Let2Own',
  Balance = 'Balance',
}

export enum DirectDebitAccountType {
  Let2Own = 'Let2Own',
  Standard = 'Standard',
}

export enum DirectDebitPayeeAccountType {
  Business = 'Business',
  Personal = 'Personal',
}

export interface DirectDebitWebConfig {
  ddWebConfigurationId: number;
  effectiveFromDt: string;
  effectiveToDt: string;
  numberOfOccurrences: number;
  paymentDay: number;
  startMonth: number;
  startYear: number;
  accountType: DirectDebitAccountType;
  balanceType: DirectDebitBalanceType;
}

export interface DirectDebitConfigResponse {
  currentConfig: DirectDebitWebConfig;
}

export interface DirectDebitCreationDetails {
  balanceType: DirectDebitBalanceType;
  payeeAccountType: DirectDebitPayeeAccountType;
  bankAccountName: string;
  bankSortCode: string;
  bankAccountNumber: string;
  amount: number;
  numberOfMonths: number;
}

export interface Let2OwnBalance {
  balance: number | null;
  lettingIncome?: number | null;
  oneOffPayment: {
    amount: number;
    balanceAfterPayment: number;
  } | null;
}

interface DirectDebitSubSummary {
  canSetUpDD: boolean;
  // Every term the owner may choose from, shortest first, already filtered to
  // what the park is eligible for. The first entry is the default. Optional so
  // the page still renders against a service released before this field existed.
  scheduleOptions?: DirectDebitWebConfig[];
  directDebit: DirectDebit | null;
}

export interface DirectDebitSummary {
  standardDirectDebit: DirectDebitSubSummary;
  let2OwnDirectDebit: DirectDebitSubSummary;
  balance: {
    standard: number | null;
    let2Own: number | null;
  };
}
